/* global ma */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioAllPublisherPageApi = createApi({
  reducerPath: 'audioAllPublisherPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioAllPublisherPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudioAllPublisherData: builder.query({
      query: () => ({
        url : 'all_publisher',
        method: 'POST',
        body : {
            "phone": "",
            "platform": "miniapp",
            "udid": "190740e5f0032702",
            "user_id": getLocalStorageData(),
            "version_code": 29,
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchAudioAllPublisherDataQuery, endpoints } = audioAllPublisherPageApi;